"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddinChatScreen = AddinChatScreen;
var _button = require("@design/ui/button");
var _inputGroup = require("@design/ui/input-group");
var _kbd = require("@design/ui/kbd");
var _addinChat = require("./addin-chat.wiring");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function AddinChatScreen() {
  var _w$greetingGreeting, _w$inputGroupContent, _w$inputGroupAddonSlo, _w$buttonShowIconStar, _w$buttonShowKbd, _w$kbdShowLeftIcon, _w$kbdLabel, _w$kbdShowRightIcon, _w$buttonShowIconEnd;
  var w = (0, _addinChat.useWiring)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      justifyContent: "center",
      alignItems: "center",
      padding: "0px 12px 0px 12px",
      width: "100%",
      alignSelf: "stretch",
      maxWidth: "800px"
    },
    "data-sentry-component": "AddinChatScreen",
    "data-sentry-source-file": "addin-chat.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        alignSelf: "stretch"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          alignSelf: "stretch",
          color: "rgba(10, 10, 10, 1)",
          fontFamily: "Lora",
          fontSize: "18px",
          fontWeight: "400",
          lineHeight: "24px",
          letterSpacing: "-0.9px",
          textAlign: "center"
        },
        children: (_w$greetingGreeting = w.greetingGreeting) !== null && _w$greetingGreeting !== void 0 ? _w$greetingGreeting : "How can I help you, Laurie?"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        justifyContent: "flex-end",
        alignItems: "center",
        alignSelf: "stretch"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroup, _objectSpread(_objectSpread({}, w.inputGroup), {}, {
        className: "h-auto flex-col",
        "data-sentry-element": "InputGroup",
        "data-sentry-source-file": "addin-chat.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            alignItems: "flex-start",
            alignSelf: "stretch"
          },
          children: (_w$inputGroupContent = w.inputGroupContent) !== null && _w$inputGroupContent !== void 0 ? _w$inputGroupContent : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupTextarea, _objectSpread(_objectSpread({}, w.inputGroupInput), {}, {
              placeholder: "What would you like to know?"
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupAddon, _objectSpread(_objectSpread({}, w.inputGroupAddon), {}, {
              align: "inline-end",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "row",
                  gap: "8px",
                  alignItems: "center",
                  flexGrow: "1",
                  flexBasis: "0",
                  minWidth: "0",
                  alignSelf: "stretch"
                },
                children: (_w$inputGroupAddonSlo = w.inputGroupAddonSlot) !== null && _w$inputGroupAddonSlo !== void 0 ? _w$inputGroupAddonSlo : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, _objectSpread(_objectSpread({}, w.button), {}, {
                      variant: "ghost",
                      size: "default",
                      disabled: true,
                      children: [((_w$buttonShowIconStar = w.buttonShowIconStart) !== null && _w$buttonShowIconStar !== void 0 ? _w$buttonShowIconStar : true) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                        src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cmask%20id%3D%22mask0_0_346%22%20style%3D%22mask-type%3Aalpha%22%20maskUnits%3D%22userSpaceOnUse%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2216%22%20height%3D%2216%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22%23D9D9D9%22%2F%3E%0A%3C%2Fmask%3E%0A%3Cg%20mask%3D%22url(%23mask0_0_346)%22%3E%0A%3Cpath%20d%3D%22M7.57786%2013.163C7.46428%2013.0495%207.40749%2012.9087%207.40749%2012.7408V8.59267H3.25934C3.09144%208.59267%202.9507%208.53588%202.83712%208.4223C2.72354%208.30872%202.66675%208.16798%202.66675%208.00008C2.66675%207.83218%202.72354%207.69144%202.83712%207.57786C2.9507%207.46428%203.09144%207.40749%203.25934%207.40749H7.40749V3.25934C7.40749%203.09144%207.46428%202.9507%207.57786%202.83712C7.69144%202.72354%207.83218%202.66675%208.00008%202.66675C8.16798%202.66675%208.30872%202.72354%208.4223%202.83712C8.53588%202.9507%208.59267%203.09144%208.59267%203.25934V7.40749H12.7408C12.9087%207.40749%2013.0495%207.46428%2013.163%207.57786C13.2766%207.69144%2013.3334%207.83218%2013.3334%208.00008C13.3334%208.16798%2013.2766%208.30872%2013.163%208.4223C13.0495%208.53588%2012.9087%208.59267%2012.7408%208.59267H8.59267V12.7408C8.59267%2012.9087%208.53588%2013.0495%208.4223%2013.163C8.30872%2013.2766%208.16798%2013.3334%208.00008%2013.3334C7.83218%2013.3334%207.69144%2013.2766%207.57786%2013.163Z%22%20fill%3D%22%233F3C38%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E",
                        alt: "Icon/Add",
                        style: {
                          width: "16px",
                          maxWidth: "100%",
                          height: "16px"
                        }
                      }) : null, ((_w$buttonShowKbd = w.buttonShowKbd) !== null && _w$buttonShowKbd !== void 0 ? _w$buttonShowKbd : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_kbd.Kbd, _objectSpread(_objectSpread({}, w.kbd), {}, {
                        children: [((_w$kbdShowLeftIcon = w.kbdShowLeftIcon) !== null && _w$kbdShowLeftIcon !== void 0 ? _w$kbdShowLeftIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                          style: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "9px",
                            maxWidth: "100%",
                            height: "12px"
                          },
                          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                            style: {
                              alignSelf: "stretch",
                              flexGrow: "1",
                              flexBasis: "0",
                              minHeight: "0"
                            },
                            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                              style: {
                                backgroundColor: "rgba(100, 97, 92, 1)"
                              }
                            })
                          })
                        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                          style: {
                            color: "rgba(142, 138, 131, 1)",
                            fontFamily: "Inter",
                            fontSize: "10px",
                            fontWeight: "400",
                            lineHeight: "16px",
                            letterSpacing: "0.1px",
                            textAlign: "center"
                          },
                          children: (_w$kbdLabel = w.kbdLabel) !== null && _w$kbdLabel !== void 0 ? _w$kbdLabel : "⌘"
                        }), ((_w$kbdShowRightIcon = w.kbdShowRightIcon) !== null && _w$kbdShowRightIcon !== void 0 ? _w$kbdShowRightIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                          style: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "9px",
                            maxWidth: "100%",
                            height: "12px"
                          },
                          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                            style: {
                              alignSelf: "stretch",
                              flexGrow: "1",
                              flexBasis: "0",
                              minHeight: "0"
                            },
                            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                              style: {
                                backgroundColor: "rgba(100, 97, 92, 1)"
                              }
                            })
                          })
                        }) : null]
                      })) : null, ((_w$buttonShowIconEnd = w.buttonShowIconEnd) !== null && _w$buttonShowIconEnd !== void 0 ? _w$buttonShowIconEnd : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "12px",
                          maxWidth: "100%",
                          height: "16px"
                        },
                        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                          style: {
                            alignSelf: "stretch",
                            flexGrow: "1",
                            flexBasis: "0",
                            minHeight: "0"
                          },
                          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                            style: {
                              backgroundColor: "rgba(100, 97, 92, 1)"
                            }
                          })
                        })
                      }) : null]
                    }))
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                      flexGrow: "1",
                      flexBasis: "0",
                      minWidth: "0",
                      height: "1px"
                    }
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, _objectSpread(_objectSpread({}, w.button2), {}, {
                      variant: "default",
                      size: "icon",
                      disabled: true,
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                        src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M6.75325%209.24603C6.65134%209.14429%206.52987%209.06425%206.39619%209.01073L2.16734%207.31493C2.11685%207.29467%202.07377%207.25945%202.04387%207.21399C2.01397%207.16854%201.99869%207.11503%202.00009%207.06064C2.00148%207.00625%202.01948%206.95359%202.05166%206.90973C2.08385%206.86587%202.12868%206.8329%202.18014%206.81525L12.3123%203.34898C12.3596%203.33192%2012.4107%203.32866%2012.4597%203.33959C12.5088%203.35053%2012.5537%203.3752%2012.5892%203.41072C12.6247%203.44625%2012.6494%203.49115%2012.6603%203.54019C12.6713%203.58922%2012.668%203.64036%2012.6509%203.68761L9.18467%2013.8198C9.16702%2013.8712%209.13405%2013.9161%209.09019%2013.9483C9.04633%2013.9804%208.99367%2013.9984%208.93928%2013.9998C8.88489%2014.0012%208.83138%2013.9859%208.78593%2013.956C8.74047%2013.9262%208.70525%2013.8831%208.68499%2013.8326L6.98919%209.60266C6.93543%209.46907%206.85517%209.34776%206.75325%209.24603ZM6.75325%209.24603L12.5875%203.41297%22%20stroke-width%3D%221.002%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%23F4F6FB%22%2F%3E%0A%3C%2Fsvg%3E",
                        alt: "send",
                        style: {
                          width: "16px",
                          maxWidth: "100%",
                          height: "16px"
                        }
                      })
                    }))
                  })]
                })
              })
            }))]
          })
        })
      }))
    })]
  });
}